import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

import { COLORS } from "../constants/colors";
import { containerVariants, cardVariants, fadeUp } from "../utils/variants";

const Career = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    message: "",
  });
 const [index, setIndex] = useState(0);

  const ads = [
  {
    img: "/assets/billing.jpeg",
    link: "https://softcoders.in",
  },
  {
    img: "/assets/sc.jpeg",
    link: "https://softcoders.in",
  },
  {
    img: "/assets/to1.png",
    link: "https://softcoders.in",
  },
];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 4000); // 3 sec

    return () => clearInterval(interval);
  }, []);
  const formRef = useRef(null); // Create a ref for the form section

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
    });
  }, []);

  // Handle scroll to the form when the Apply Now button is clicked
  const handleScrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Handle form data change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission to WhatsApp
  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, position, message } = formData;
    const whatsappMessage = `*New Job Application*\n\n *Name*: ${name}\n*Email*: ${email}\n*Phone*: ${phone}\n*Position*: ${position}\n*Message*: ${message}`;
    
    const whatsappURL = `https://wa.me/919254147455?text=${encodeURIComponent(whatsappMessage)}`; 
        window.open(whatsappURL, "_blank");
  };

  return (
    <div className="w-full" style={{ backgroundColor: COLORS.background, color: COLORS.textPrimary }}>
      {/* 🔹 Hero Section */}
      <section
        className="relative h-[550px] flex items-center justify-start bg-cover bg-center px-6 sm:px-10 md:px-20 lg:px-32"
        style={{
          backgroundImage: "url('/assets/deals.png')", // ✅ replaced img tag with background image
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Text Content */}
        <div className="relative z-10 text-left w-full mt-20 md:mt-28">
          <motion.h1
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-4"
          >
            Career
          </motion.h1>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            transition={{ delay: 0.3 }}
            className="text-white font-semibold text-lg md:text-xl tracking-wide"
          >
            Join our dynamic team and shape the future together.
          </motion.p>
        </div>
      </section>

      {/*  Current Job Openings */}
      <motion.section
        className="py-16 px-6 sm:px-10 md:px-20 lg:px-32 text-center"
        style={{ backgroundColor: COLORS.light }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2
          className="text-3xl sm:text-4xl font-bold mb-10"
          style={{ color: COLORS.primary }}
          variants={fadeUp}
        >
          Current Job Openings
        </motion.h2>

        <motion.div
          className="shadow-lg rounded-2xl p-8 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10"
          style={{ backgroundColor: COLORS.white }}
          variants={cardVariants}
        >
          {/* Left Section */}
          <motion.div className="flex-1 text-left" variants={fadeUp}>
            <h3 className="text-2xl font-bold mb-4" style={{ color: COLORS.primaryDark }}>
              Marketing Executive
            </h3>
            <ul className="space-y-3" style={{ color: COLORS.textSecondary }}>
              <li><strong>Qualification:</strong> Graduate in any stream</li>
              <li><strong>Experience:</strong> Minimum 1 Year Experience</li>
              <li><strong>Location:</strong> Haryana, Punjab, Rajasthan, Delhi, NCR, Chandigarh</li>
              <li><strong>Job Field:</strong> IT / Software Services</li>
              <li><strong>Salary:</strong> Attractive Salary + Incentive + TA + DA</li>
              <li><strong>Skills:</strong> Good English & Computer Knowledge</li>
            </ul>

            <div className="mt-8">
              <button
                className="px-6 py-2 rounded-lg font-semibold transition duration-300"
                style={{
                  backgroundColor: COLORS.primary,
                  color: COLORS.white,
                }}
                onClick={handleScrollToForm} 
              >
                Apply Now
              </button>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div className="flex-1" variants={fadeUp}>
            <img
              src="/assets/team.png"
              alt="Marketing Executive"
              className="rounded-xl shadow-md w-full h-80 object-cover"
            />
          </motion.div>
        </motion.div>
      </motion.section>

      {/*  Why Join Us */}
      <motion.section
        className="py-20 px-6 sm:px-10 md:px-20 lg:px-32 text-center"
        style={{ backgroundColor: COLORS.background }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2
          className="text-3xl sm:text-4xl font-bold mb-12"
          style={{ color: COLORS.primary }}
          variants={fadeUp}
        >
          Why Join Us
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {[ 
            { title: "Growth Opportunities", desc: "Work on innovative projects and grow your professional skills." },
            { title: "Supportive Culture", desc: "We believe in teamwork, collaboration, and work-life balance." },
            { title: "Learning Environment", desc: "Get mentorship and continuous learning opportunities." },
            { title: "Rewarding Benefits", desc: "Competitive pay, incentives, and recognition for your efforts." },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="rounded-xl p-6 shadow-md hover:shadow-lg transition"
              style={{ backgroundColor: COLORS.primaryLight }}
              variants={cardVariants}
            >
              <h4 className="text-xl font-semibold mb-2" style={{ color: COLORS.primaryDark }}>
                {item.title}
              </h4>
              <p style={{ color: COLORS.textSecondary }}>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/*  Hiring Process */}
      <motion.section
        className="py-20 px-6 sm:px-10 md:px-20 lg:px-32 text-center"
        style={{ backgroundColor: COLORS.light }}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2
          className="text-3xl sm:text-4xl font-bold mb-12"
          style={{ color: COLORS.primary }}
          variants={fadeUp}
        >
          Our Hiring Process
        </motion.h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-10 max-w-5xl mx-auto">
          {[
            "Apply Online",
            "HR Screening",
            "Technical Interview",
            "Final Discussion",
            "Offer & Onboarding",
          ].map((step, i) => (
            <motion.div
              key={i}
              className=" shadow-md rounded-xl p-6 w-48 min-h-40 flex flex-col items-center"
              style={{ backgroundColor: COLORS.white }}
              variants={cardVariants}
            >
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center font-bold mb-3"
                style={{
                  backgroundColor: COLORS.primary,
                  color: COLORS.white,
                }}
              >
                {i + 1}
              </div>
              <p className="font-semibold" style={{ color: COLORS.textPrimary }}>
                {step}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/*  Apply Form */}
     {/*  Apply Form */}
<motion.section
  className="py-16 px-6"
  style={{ backgroundColor: COLORS.light }}
  variants={containerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  ref={formRef}
>
  {/* 🔹 NEW WRAPPER */}
  <div className="relative flex flex-col md:flex-row items-start gap-10">

    {/* 🔹 LEFT SIDE - ADS (NEW ADDITION) */}
    <div className="w-full md:w-1/3 md:pl-6">
      <p className="text-sm text-gray-400 mb-3">Sponsored</p>

      <div className="overflow-hidden rounded-xl ">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {ads.map((ad, i) => (
            <div key={i} className="min-w-full flex-shrink-0">
              <a href={ad.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={ad.img}
                  alt="Ad"
                  className="w-68  h-48 object-cover rounded-xl"
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* 🔹 RIGHT SIDE - YOUR ORIGINAL FORM (UNCHANGED) */}
    <div className="w-full flex justify-center">

      {/* ⬇️ YOUR ORIGINAL CODE STARTS (NO CHANGE) */}
      <motion.div
        className="max-w-3xl mx-auto rounded-2xl shadow-lg p-10"
        style={{ backgroundColor: COLORS.white }}
        variants={fadeUp}
      >
        <h2 className="text-3xl font-bold mb-4" style={{ color: COLORS.primaryDark }}>
          Apply for a Job
        </h2>

        <p className="mb-8" style={{ color: COLORS.textSecondary }}>
          Interested in joining our team? Fill out the form below and we’ll get in touch soon!
        </p>

        <motion.form variants={containerVariants} onSubmit={handleSubmit}>
          <div className="flex flex-wrap gap-4 mb-4">
            {["name", "email"].map((field, i) => (
              <motion.input
                key={i}
                type={field === "email" ? "email" : "text"}
                placeholder={`Enter your ${field}`}
                name={field}
                value={formData[field]}
                onChange={handleInputChange}
                required
                className="flex-1 min-w-[250px] p-3 border rounded-lg outline-none"
                style={{
                  borderColor: COLORS.medium,
                  color: COLORS.textPrimary,
                }}
                variants={cardVariants}
              />
            ))}
          </div>

          <div className="flex flex-wrap gap-4 mb-4">
            {["phone", "position"].map((field, i) => (
              <motion.input
                key={i}
                type="text"
                placeholder={`Enter your ${field}`}
                name={field}
                value={formData[field]}
                onChange={handleInputChange}
                required
                className="flex-1 min-w-[250px] p-3 border rounded-lg outline-none"
                style={{
                  borderColor: COLORS.medium,
                  color: COLORS.textPrimary,
                }}
                variants={cardVariants}
              />
            ))}
          </div>

          <motion.textarea
            placeholder="Write a short message..."
            rows="4"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            className="w-full p-3 border rounded-lg mb-6 outline-none"
            style={{
              borderColor: COLORS.medium,
              color: COLORS.textPrimary,
            }}
            variants={cardVariants}
          />

          <motion.button
            type="submit"
            className="px-8 py-3 rounded-lg font-semibold transition duration-300"
            style={{
              backgroundColor: COLORS.primary,
              color: COLORS.white,
            }}
            variants={cardVariants}
          >
            Submit Application
          </motion.button>
        </motion.form>
      </motion.div>
      {/* ⬆️ YOUR ORIGINAL CODE ENDS */}

    </div>
  </div>
</motion.section>
    </div>
  );
};

export default Career;
